function parseShadow ({
  type,
  angle = 0,
  blur = { value: 0, unit: 'px' },
  size = { value: 0, unit: 'px' },
  distance = { value: 0, unit: 'px' },
  color = 'var(--color-greyDefault)'
}) {
  const radian = angle * Math.PI / 180 - Math.PI / 2

  const sin = Math.sin(radian)

  const cos = Math.cos(radian)

  const y = sin * distance.value

  const x = cos * distance.value

  const verticalOffset = y + distance.unit
  
  const horizontalOffset = x + distance.unit

  const blurRadius = blur.value + blur.unit

  const spreadRadius = size.value + size.unit

  let boxShadow = `${horizontalOffset} ${verticalOffset} ${blurRadius} ${spreadRadius} ${color}`

  if (type === 'inside') {
    boxShadow = `inset ${boxShadow}`
  }

  return { boxShadow }
}

export default parseShadow
